import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { SearchTermEntriesPage } from '@/components/Ams/focus/SearchTermEntriesPage'
import { searchTermEntriesSearchSchema } from '@/components/Ams/focus/entries'
import { pruned } from '@/components/Ams/search'

/** Wiring only. The schema lives beside the page. */
export const Route = createFileRoute('/_app/focused-data/search-term/history/')({
  validateSearch: searchTermEntriesSearchSchema,
  component: HistoryRoute,
})

function HistoryRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SearchTermEntriesPage
      search={search}
      onSearchChange={(next) =>
        void navigate({ search: (current) => pruned({ ...current, ...next }), replace: true })
      }
    />
  )
}
